/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

dataLayer.push({
  event: "pageview",
  page_location: window.theme.path,
  page_type: window.theme.pageType,
  customer_id: window.customer.id,
  login_status: window.customer.id ? "logged" : "guest",
  store_country: window.theme.country,
  site_language: window.theme.language,
  currency: window.theme.currency,
  responsive_layout: window.theme.isMobile ? "mobile" : "desktop",
});

document.addEventListener("product:added", function (event) {
  dataLayer.push({
    event: "add_to_cart",
  });
});

document.addEventListener("variant:changed", function (event) {
  const variant = event.detail.variant;
  dataLayer.push({
    event: "select_content",
    content_type: "size_selector",
    item_id: variant.option1,
  });
});

// console.log("dayaLayer", dataLayer);

const productDetails = document.querySelector(".Product__Details");
if (productDetails) {
  const entries = document.querySelectorAll(".Product__Details__entry");
  const entriesTitles = document.querySelectorAll(".Product__Details--main > li.Product__Details__entry");

  const handleChangeDetail = (index) => {
    const currentActive = document.querySelectorAll(".Product__Details__entry--is-active");

    let newIsDifferent = false;
    currentActive.forEach((current) => {
      newIsDifferent = current.dataset.detailIndex !== index;
      if (window.innerWidth >= 1024) {
        current.classList.remove("Product__Details__entry--is-active");
      }
    });

    // in mobile le dropdown devono stare aperte anche se seleziono più voci
    if (window.innerWidth < 1024) {
      const clickedDetail = document.querySelectorAll(`.Product__Details__entry[data-detail-index="${index}"]`);

      clickedDetail.forEach((detail) => {
        if (detail.classList.contains("Product__Details__entry--is-active")) {
          detail.classList.remove("Product__Details__entry--is-active");
        } else {
          detail.classList.add("Product__Details__entry--is-active");
        }
      });
    } else {
      if (newIsDifferent || Array.from(currentActive).length === 0) {
        const entriesToActive = Array.from(entries).filter((entry) => entry.dataset.detailIndex === index);
        entriesToActive.forEach((entry) => {
          entry.classList.add("Product__Details__entry--is-active");
        });
      }
    }
  };

  entriesTitles.forEach((entry) => {
    entry.addEventListener("click", () => handleChangeDetail(entry.dataset.detailIndex));
  });

  window.addEventListener("resize", () => {
    // al resize della finestra faccio il reset dei dettagli aperti, nel caso
    // ne avessi selezionat >1 in mobile
    const entries = document.querySelectorAll(".Product__Details__entry");
    const currentActives = document.querySelectorAll(".Product__Details__entry--is-active");
    if (window.innerWidth >= 1024 && Array.from(currentActives).length > 2) {
      // console.log("search for actives");
      currentActives.forEach((current) => {
        current.classList.remove("Product__Details__entry--is-active");
      });
      // faccio stare aperta solo la prima voce
      const entriesToActive = Array.from(entries).filter((entry) => entry.dataset.detailIndex === "1");
      entriesToActive.forEach((entry) => {
        entry.classList.add("Product__Details__entry--is-active");
      });
    }
  });
}

const productOptions = document.querySelectorAll(".ProductForm__Item");

if (productOptions) {
  // const handleOpenOptionList = (optionList) => {
  // 	console.log(optionList.classList);
  // 	optionList.classList.toggle("Popover__ValueList--is-open");
  // };

  productOptions.forEach((option, i) => {
    option.addEventListener("click", (e) => {
      let optionButton = e.target.classList.contains(".ProductForm__Item") ? e.target : e.target.closest(".ProductForm__Item");

      const isMenuOpen = optionButton.getAttribute("aria-expanded") === "true" ? true : false;

      optionButton.setAttribute("aria-expanded", !isMenuOpen);
    });
  });

  let valueLists = document.querySelectorAll(".ProductForm__Item");
  if (Array.from(valueLists).length) {
    document.addEventListener("mouseup", function (e) {
      valueLists.forEach((list) => {
        if (!list.contains(e.target)) {
          list.setAttribute("aria-expanded", false);
        }
      });
    });
  }
}

navbar = document.getElementById("shopify-section-header"); // Get The NavBar
if (navbar) {
  const shrinkedTop = 75;
  const extendedTop = 30;
  let isShrinked = false;

  // var box = document.createElement("div");
  // box.style.position = "fixed";
  // box.style.top = "0px";
  // box.style.right = "0px";
  // box.style.width = "200px";
  // box.style.color = "black";
  // box.style.background = "lightblue";
  // box.style.padding = "20px";
  // box.style.zIndex = "999";
  // box.innerHTML =
  // 	"<div><div><span>scrollTop:</span><span id='scrollTop'>0</span></div><div><span>WindowOffset:</span><span id='wtop'>0</span></div><div><span>State:</span><span id='state'>?</span></div><div><span>isShrinked:</span><span id='isShrinked'>?</span></div></div>";
  // document.body.appendChild(box);
  // handleScroll();

  const handleScroll = () => {
    // console.log("handleScroll");
    // console.log(isShrinked);
    // console.log(scrollTop);
    const scrollTop = navbar.offsetTop;
    // document.querySelector("#scrollTop").innerHTML = scrollTop;
    // document.querySelector("#wtop").innerHTML = window.scrollY;
    if (!isShrinked) {
      // box.style.background = "red";
      if (window.scrollY > shrinkedTop) {
        // console.log(
        // 	"I will shrink because my top is " + scrollTop + " which is > " + shrinkedTop
        // );
        navbar.classList.add("Header--shrinked");
        document.documentElement.style.setProperty("--header-height", "70px");
        document.getElementById("shopify-section-announcement").style.display = "none";
        isShrinked = true;
        // document.querySelector("#state").innerHTML = "SHRINKED";
      }
    }
    if (isShrinked) {
      // box.style.background = "green";
      if (window.scrollY < extendedTop) {
        // console.log(
        // 	"I will extend because my top is " + scrollTop + " which is < " + extendedTop
        // );
        navbar.classList.remove("Header--shrinked");
        document.documentElement.style.setProperty("--header-height", "114px");
        document.getElementById("shopify-section-announcement").style.display = "block";
        isShrinked = false;
        // document.querySelector("#state").innerHTML = "EXTENDED";
      }
    }

    // document.querySelector("#isShrinked").innerHTML = isShrinked;
  };

  window.addEventListener("scroll", function () {
    //it should be debounced, but you know... beauty and yadda yadda...
    handleScroll();
  });

  // window.addEventListener("load", (event) => {
  // window.addEventListener("scroll", function () {
  // 	debounce(handleScroll, 0);
  // });
  // });
}

const debounce = (method, delay) => {
  clearTimeout(method._tId);
  method._tId = setTimeout(function () {
    method();
  }, delay);
};

const glossary = document.querySelector('[data-section-type="glossary"]');

if (glossary) {
  const glossaryItems = glossary.querySelectorAll('[data-action="open-glossary"]');

  glossaryItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (e.target.closest(".Glossary__Entry").dataset.action === "open-glossary") {
        closeAll();
        item.setAttribute("aria-expanded", true);
      }
    });
  });

  const closeAll = () => {
    glossary.querySelector('[aria-expanded="true"').removeAttribute("aria-expanded");
  };
}

// Function to show Language selector megamenu

const LanguageBtn = document.querySelector("[data-open='menu-language']");
const menuLanguage = document.getElementById("header-currency");
const BtnLangTriggerFooterDesk = document.getElementById("footer_language_desk");
const HeaderDiv = document.getElementById("section-header");

LanguageBtn.addEventListener("click", (e) => {
  if (menuLanguage.getAttribute("aria-hidden") == "true") {
    menuLanguage.setAttribute("aria-hidden", "false");
  } else {
    menuLanguage.setAttribute("aria-hidden", "true");
  }
});

menuLanguage.addEventListener("mouseleave", (e) => {
  menuLanguage.setAttribute("aria-hidden", "true");
});

// Trigger for open the country selector from footer link on desktop
BtnLangTriggerFooterDesk.addEventListener("click", (e) => {
  setTimeout(() => {
    if (HeaderDiv.classList.contains("Header--transparent")) {
      HeaderDiv.classList.remove("Header--transparent");
    }
    if (menuLanguage.getAttribute("aria-hidden") == "true") {
      menuLanguage.setAttribute("aria-hidden", "false");
    } else {
      menuLanguage.setAttribute("aria-hidden", "true");
    }
  }, 700);
});

// Function to submit country and language form

const LanguageList_Header = Array.from(document.querySelectorAll("#LanguageList .Language"));
const CountryList_Header = Array.from(document.querySelectorAll("#CountryList a"));
const LanguageList_Footer = Array.from(document.querySelectorAll("#LanguageList_Footer .Language"));
const CountryList_Footer = Array.from(document.querySelectorAll("#CountryList_Footer .Country__button"));
const inputCurrency_Header = document.querySelector("#localization_form_header input[name='country_code']");
const inputLang_Header = document.querySelector("#localization_form_header input[name='locale_code']");
const inputCurrency_Footer = document.querySelector("#localization_form_footer input[name='country_code']");
const inputLang_Footer = document.querySelector("#localization_form_footer input[name='locale_code']");
const ButtonLocal_Header = document.getElementById("submitLocal");
const ButtonLocal_Footer = document.getElementById("submitLocalFooter");
const LocalForm_Header = document.getElementById("localization_form_header");
const LocalForm_Footer = document.getElementById("localization_form_footer");
const ButtonLocal_Sidemenu = $("#country-trigger");
const ButtonOpenLanguageFooter = $("[aria-controls='footer-currency-popover']");

setInputLanguageValue(LanguageList_Header, inputLang_Header);
setInputLanguageValue(CountryList_Header, inputCurrency_Header);

setInputLanguageValue(LanguageList_Footer, inputLang_Footer);
setInputLanguageValue(CountryList_Footer, inputCurrency_Footer);

ButtonLocal_Header.addEventListener("click", (e) => {
  e.preventDefault();
  LocalForm_Header.submit();
});

ButtonLocal_Footer.addEventListener("click", (e) => {
  e.preventDefault();
  LocalForm_Footer.submit();
});

// Trigger for open the country selector from the sidemenu mobile
ButtonLocal_Sidemenu.on("click", (e) => {
  ButtonOpenLanguageFooter.trigger("click");
});
// ------

function setInputLanguageValue(array, inpt) {
  for (const local of array) {
    local.addEventListener("click", (e) => {
      array.forEach((el) => {
        if (el.classList.contains("is-selected")) {
          el.classList.remove("is-selected");
        }
      });
      local.classList.add("is-selected");
      let valore = local.getAttribute("value");
      inpt.value = valore;
    });
  }
}

// Function to change Valute "show more" CTA text
const ShowMoreText = document.querySelectorAll(".ShowMore__CTA");

ShowMoreText.forEach((el) => {
  el.addEventListener("click", (e) => updateTextCTA(e.target));
});

function updateTextCTA(cta) {
  ActualText = cta.innerHTML;
  NewText = cta.getAttribute("data-translate");
  cta.innerHTML = NewText;
  cta.setAttribute("data-translate", ActualText);
}

// Function to force scroll-to-anchor in About page,
// because timeline component load image to late and layoout shift

document.addEventListener("DOMContentLoaded", function () {
  const goTo = setTimeout(() => {
    const AncorArray = ["#glossary", "#store"];
    const urlArray = window.location.href.split("/");
    const lastUrlElement = urlArray.pop();

    AncorArray.forEach((ancor) => {
      if (lastUrlElement == ancor) {
        location.href = ancor;
        return;
      }
    });
  }, 1500);
});

// Video pagina fit con Plyr

const FitVideoArray = Array.from(document.querySelectorAll(".plyr__video-embed"));
const players = FitVideoArray.map((p) => {
  new Plyr(p, {
    muted: true,
    volume: 0,
  });
  // console.log(p);
});

const addCheckboxTermsListener = (selector, event, handler) => {
  let rootElement = document.querySelector('[data-section-type="cart"]');
  rootElement.addEventListener(
    event,
    function (evt) {
      var targetElement = evt.target;
      while (targetElement != null) {
        if (targetElement.matches(selector)) {
          handler(evt);
          return;
        }
        targetElement = targetElement.parentElement;
      }
    },
    true
  );
};

const checkTermsCheckbox = (e) => {
  const checkoutForm = e.target.closest("form");

  const termsInput = checkoutForm.querySelector("#terms-check");

  if (!termsInput.checked) {
    alert(window.languages.termsNotify);
    e.preventDefault();
    return;
  }
};

const logUserCheck = (e) => {
  const checkoutForm = e.target.closest("form");
  const termsInput = checkoutForm.querySelector("#terms-check");

  const termsRecordInput = checkoutForm.querySelector("#agreed-to-the-terms-and-conditions-on");
  termsRecordInput.value = termsInput.checked ? new Date() : "";
};

const isCartVisible = document.querySelector('[data-section-type="cart"]');

if (isCartVisible) {
  addCheckboxTermsListener("button[name=checkout]", "click", checkTermsCheckbox);
  addCheckboxTermsListener('[data-role="cart-terms-checkbox"]', "click", logUserCheck);
}

/**
 * Carousels Fits,  Announcement Bar and Comparison
 */

const splidesArray = Array.from(document.querySelectorAll("[data-carousel-splide]"));

for (let carousel of splidesArray) {
  if (carousel.getAttribute("data-carousel-splide") == "fit-carousel") {
    new Splide(carousel, { arrows: false }).mount();
  } else if (carousel.getAttribute("data-carousel-splide") == "announcement-bar") {
    const carouselSpeed = carousel.getAttribute("data-splide-speed");

    new Splide(carousel, {
      type: "loop",
      autoplay: true,
      perPage: 1,
      focus: 0,
      arrows: false,
      pagination: false,
      speed: carouselSpeed,
    }).mount();
  } else if (carousel.getAttribute("data-carousel-splide") == "comparison-carousel") {
   const comparisonCarousel = new Splide(carousel, {
      type: "loop",
      perPage: 3,
      focus: "center",
      start: 1,
      gap: "20px",
      arrows: true,
      pagination: false,
      width: "90%",
      breakpoints: {
        640: {
          perPage: 1,
        },
      }

    }).mount();
    const CarouselInfoArray = Array.from(document.querySelectorAll(".CarouselComparison_InfoItem"));
    console.log("🚀 ~ CarouselInfoArray:", CarouselInfoArray)
    const firstSlideActive = carousel.querySelectorAll(".splide__slide.is-visible.is-active")[0].getAttribute("data-block-id")

    for (let CarouselInfo of CarouselInfoArray) {
      CarouselInfo_ID = CarouselInfo.getAttribute("data-block-id")
      if(CarouselInfo_ID === firstSlideActive) {
        CarouselInfo.classList.add("is-active");
      }
    }

    comparisonCarousel.on("active", (e) =>{
      const slideActive = e.slide
      const slideActiveId = slideActive.getAttribute("data-block-id")

      for (let CarouselInfo of CarouselInfoArray) {
        CarouselInfo_ID = CarouselInfo.getAttribute("data-block-id")
          

        
        if(CarouselInfo_ID === slideActiveId) {
          CarouselInfo.classList.add("is-active");
        } else {
          CarouselInfo.classList.remove("is-active");
        }
      }
      
    })
  }
}

